import React from 'react';
import { exportMeetingPdf } from '@/utils/exportMeetingPdf';
import Logo from '@/assets/Pitchster-logo-final.png';

interface MeetingPDFReportProps {
  meeting?: any;
  rawData?: any;
  talkRatioData?: any;
  isDark?: boolean;
}

export const MeetingPDFReport: React.FC<MeetingPDFReportProps> = ({
  meeting,
  rawData,
  talkRatioData: _talkRatioData,
  isDark = true,
}) => {
  const payload = rawData || meeting;

  const handleDownload = () => {
    exportMeetingPdf({
      data: payload,
      hasMeetingNotes: Boolean(
        meeting?.meetingNotes ||
          payload?.meetingNotes ||
          meeting?.notes ||
          payload?.notes ||
          meeting?.ai_notes ||
          payload?.ai_notes ||
          meeting?.meetingPurpose?.length ||
          meeting?.meetingObjective?.length ||
          payload?.ai_summary ||
          payload?.feedback,
      ),
      aiPersonaName: meeting?.customerContact?.fullName || meeting?.salesRep,
      meetingDate: meeting?.createdAt || payload?.createdAt,
      userName: meeting?.salesRep || payload?.salesRep,
      logoUrl: Logo,
    });
  };

  return (
    <button
      onClick={handleDownload}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 7,
        padding: '8px 16px',
        borderRadius: 10,
        border: `1px solid ${isDark ? 'rgba(184,248,144,0.4)' : '#5a9d50'}`,
        background: isDark ? '#B8F890' : '#5a9d50',
        color: isDark ? '#0a1608' : '#ffffff',
        fontSize: 15,
        fontWeight: 700,
        cursor: 'pointer',
        flexShrink: 0,
        transition: 'all 0.2s ease',
      }}
      onMouseEnter={(e) => (e.currentTarget.style.opacity = '0.9')}
      onMouseLeave={(e) => (e.currentTarget.style.opacity = '1')}
    >
      <svg width="15" height="15" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
      <span>Download PDF</span>
    </button>
  );
};

export default MeetingPDFReport;
